import React from "react";
import CommonTable, { HeadCell } from "src/business-types/grocery/components/CommonTable";

interface Product {
  id: number | string;
  productName: string;
  amount: number | string;
  quantity: number;
  totalPrice: number | string;
}

interface Props {
  products: Omit<Product, "id">[]; // input can omit id — we’ll generate it
}

const OrderProductsList: React.FC<Props> = ({ products }) => {
  const headCells: HeadCell<Product>[] = [
    { id: "id", label: "S.No" },
    { id: "productName", label: "Product name" },
    { id: "amount", label: "Price (QAR)", align: "right" },
    { id: "quantity", label: "Total quantity", align: "center" },
    { id: "totalPrice", label: "Total (QAR)" , align: "right", },
  ];

  const tableData: Product[] = (products || []).map((p, index) => ({
    id: index + 1,
    productName: p.productName,
    amount: Number(p.amount).toFixed(2),
    quantity: p.quantity,
    totalPrice: Number(p.totalPrice).toFixed(2),
  }));

  return (
  <div className="flex-1 min-h-0 overflow-y-auto">
    <CommonTable<Product>
      data={tableData}
      headCells={headCells}
      title="Ordered Products"
      selectable={false}
      denseToggle={false}
      pageSize={10}
      pagenation={true}
      showToolbar={false}
      className="w-full h-[80vh] overflow-auto"
    />
  </div>

  );
};

export default OrderProductsList;
